import { GeneralService } from './general.service';
import { NavController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { UserService } from './user.service';
import { Observable } from 'rxjs';
import { SecurityRight } from 'app/utility/enums';
import { HttpErrorResponse } from '@angular/common/http';
import { Constants } from 'app/utility/constants';
@Injectable({
	providedIn: 'root'
})
export class AuthGuardService 
{

	constructor(
		private navController: NavController, 
		private userService: UserService, 
		private generalService: GeneralService
	) { }
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
	{
		// console.debug("AuthGuardService canActivate called");
		return this.canActivateRoute(route, state);
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
	{
		// console.debug("AuthGuardService canActivateChild called");
		return this.canActivateRoute(route, state);
	}
	
	private async canActivateRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>
	{
		var loggedIn = (localStorage.getItem(Constants.LocalStorage_LoggedIn)=="1");
		
		if (!loggedIn)
		{	
			console.warn(`user is not authenticated`, state.url);
			this.generalService.setLastModule(state.url);

			this.navController.navigateRoot('/login');
			return false;
		}
		
		
		return this.userService.checkClientSideAuthOk();		

		// let rights = route.data["rights"] as Array<SecurityRight>;
		// console.debug("canActivateRoute", rights);

		// const rightsAccess = await this.userService.hasUserRightsAsync(rights);
		// if (rightsAccess)
		// {
		// 	if (state.url !='/authenticate') {
		// 		this.userService.clientAuthRoute = state.url;
		// 	}
		// 	return this.userService.checkClientSideAuthOk();			
		// }
		
		// console.error(`canActivateChild error`);
		// return false;
	}
}
